import * as yup from 'yup';

export interface LaborClassificationDto {
  id?: number;
  name: string;
}

export const laborClassificationInit: LaborClassificationDto = {
  name: ''
};

export interface LaborClassificationsParameters {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  filterText: string;
}

export const laborClassificationsParametersInit: LaborClassificationsParameters = {
  page: 0,
  pageSize: 10,
  sortBy: 'name',
  sortDirection: 'asc',
  filterText: ''
};

export const laborClassificationValidationSchema = yup.object({
  name: yup.string().max(200, 'Name cannot be more than 200 characters.').required('Name is required.')
});
